import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useTireSeason } from "../blocks/Tires/Results/Filters/TireSeasonFilters/useTireSeason";
import {
  DealerChassisResultsRoute,
} from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { useVehicleModelIdParam } from "../stores/useVehicleModelIdParam";
import { useGetVehicleInfo } from "./useGetVehicleInfo";
import { TireSearchResultsPayload } from "./useSearchTiresByVehicle";

export const useSearchTiresByVehicleChassis = (
  swrOptions: SWRConfiguration<FetcherResult<TireSearchResultsPayload>> = {}
): ModifiedSWRResponse<
  FetcherResult<TireSearchResultsPayload>,
  TireSearchResultsPayload
> => {
  const chassisRoute = useRouteParams(DealerChassisResultsRoute);
  const dealerId = chassisRoute?.dealerId ?? "";
  const vehicleChassis = chassisRoute?.vehicleChassis ?? "";
  const [vehicleModelId] = useVehicleModelIdParam();
  const dealer = useNullableDealerAccountInfo();
  const { data: vehicleInfo } = useGetVehicleInfo();
  const [season] = useTireSeason();

  const { data, ...result } = useSwrGet<TireSearchResultsPayload>(
    chassisRoute && vehicleInfo?.vehicleOriginalTiresize
      ? "/retailSiteWebService/parts/tire/searchTiresByVehicleChassis.php"
      : null,
    {
      dealerId,
      originalEquipmentFilter: dealer?.dealerProductFilters
        .originalEquipmentFilter
        ? "OE"
        : "ALL",
      searchFailoverMethod: "SEASON",
      season: String(season),
      vehicleChassis,
      vehicleModelId,
      vehicleSubmodelTireSizeId:
        vehicleInfo?.vehicleOriginalTiresize?.vehicleSubmodelTiresizeId ?? "",
    },
    swrOptions
  );

  return { ...result, data };
};

/**
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/rca.md
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/rfc.md
 * @see docs/worklog/TW-967-hunter-vin-results-vehicle-tire-sizes/tfc.md
 */
